import React, { useMemo } from 'react';
import agLogo from 'assets/airgarage-logo.png';
import styles from './SuggestedQuestions.module.css';

interface SuggestedQuestionsProps {
    onSelect: (question: string) => void;
}

function getRevenuePrompt(): string {
    const now = new Date();
    const prev = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const prevYearAgo = new Date(prev.getFullYear() - 1, prev.getMonth(), 1);
    const monthName = prev.toLocaleString('default', { month: 'long' });
    const prevYaMonthName = prevYearAgo.toLocaleString('default', { month: 'long' });
    return `Explain why ${monthName} ${prev.getFullYear()} revenue is higher or lower than ${prevYaMonthName} ${prevYearAgo.getFullYear()}.`;
}

const SUGGESTIONS = [
    getRevenuePrompt,
    () => 'How does my pricing compare to others in the area? Search and compare.',
    () => 'What are common themes in driver reviews?',
];

const SuggestedQuestions: React.FC<SuggestedQuestionsProps> = ({ onSelect }) => {
    const questions = useMemo(() => SUGGESTIONS.map((fn) => fn()), []);

    return (
        <div className={styles.container}>
            <div className={styles.intro}>
                <img src={agLogo} alt="AirGarage" className={styles.logo} />
                <h3 className={styles.heading}>Ask anything about your parking asset.</h3>
            </div>
            <div className={styles.samples}>
                {questions.map((q) => (
                    <button key={q} className={styles.sample} onClick={() => onSelect(q)}>
                        {q}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default SuggestedQuestions;
